import { Flex, Grid, Layout } from 'antd';

import useRightSideBanners from './useRightSideBanners';
import './rightSidebar.css';

const { Sider } = Layout;
const { useBreakpoint } = Grid;

const RightSidebar = ({
    width = 320,
    styles = {},
    hideBanners = false,
    stickyOffset = 0,
}) => {
    const screens = useBreakpoint();
    const banners = useRightSideBanners();

    return (
        <Sider
            className={`sticky right-sidebar`}
            style={{
                backgroundColor: 'transparent',
                display: !screens.xl ? 'none' : 'inherit',
                justifyContent: 'center',
                top: stickyOffset,
                ...styles,
            }}
            width={width}
        >
            <Flex vertical gap={24}>
                {!hideBanners && banners}
            </Flex>
        </Sider>
    );
};

export default RightSidebar;
